"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pro_thin_svg_icons_1 = require("@fortawesome/pro-thin-svg-icons");
var pro_duotone_svg_icons_1 = require("@fortawesome/pro-duotone-svg-icons");
var fontawesome_svg_core_1 = require("@fortawesome/fontawesome-svg-core");
fontawesome_svg_core_1.library.add(pro_solid_svg_icons_1.fas, pro_regular_svg_icons_1.far, pro_light_svg_icons_1.fal, pro_thin_svg_icons_1.fat, pro_duotone_svg_icons_1.fad);
